import api from "../api";
import ApiConstant from "../../constants/api.constants";

const tenantGuid = process.env.REACT_APP_TENAT_ID;

const CATEGORIES_CACHE_KEY = "homeCategoriesCache";
const CATEGORIES_CACHE_TIMESTAMP_KEY = "homeCategoriesCacheTimestamp";
const CACHE_DURATION_MS = 24 * 60 * 60 * 1000; // 24 hours

let categoriesCache: any[] | null = null;
let categoriesPromise: Promise<any[]> | null = null;

const isCacheValid = (): boolean => {
  const timestamp = localStorage.getItem(CATEGORIES_CACHE_TIMESTAMP_KEY);
  return timestamp ? Date.now() - parseInt(timestamp, 10) < CACHE_DURATION_MS : false;
};

const getFromLocalStorage = (): any[] | null => {
  try {
    const cachedData = localStorage.getItem(CATEGORIES_CACHE_KEY);
    if (cachedData) {
      const categories: any[] = JSON.parse(cachedData);
      return Array.isArray(categories) && categories.length > 0 ? categories : null;
    }
  } catch (error) {
    clearLocalStorage();
  }
  return null;
};

const saveToLocalStorage = (categories: any[]): void => {
  try {
    localStorage.setItem(CATEGORIES_CACHE_KEY, JSON.stringify(categories));
    localStorage.setItem(CATEGORIES_CACHE_TIMESTAMP_KEY, Date.now().toString());
  } catch (error) {
    // Silent fail
  }
};

const clearLocalStorage = (): void => {
  localStorage.removeItem(CATEGORIES_CACHE_KEY);
  localStorage.removeItem(CATEGORIES_CACHE_TIMESTAMP_KEY);
};

const fetchCategoriesFromApi = async (): Promise<any[]> => {
  const apiGetHomeCategories = ApiConstant.getHomeCategories + tenantGuid;
  const response = await api.get(apiGetHomeCategories);
  
  if (!response || !response.data) {
    return [];
  }

  const categories = Array.isArray(response.data) ? response.data : [];
  categoriesCache = categories;
  saveToLocalStorage(categories);
  
  return categories;
};

const getAllCategories = async (forceRefresh: boolean = false): Promise<any[]> => {
  if (!forceRefresh) {
    if (categoriesCache) {
      return categoriesCache;
    }

    if (isCacheValid()) {
      const cached = getFromLocalStorage();
      if (cached) {
        categoriesCache = cached;
        return cached;
      }
    } else {
      clearLocalStorage();
    }

    if (categoriesPromise) {
      return categoriesPromise;
    }
  }

  try {
    categoriesPromise = fetchCategoriesFromApi();
    const result = await categoriesPromise;
    categoriesPromise = null;
    return result;
  } catch (error) {
    categoriesPromise = null;
    console.error("[CategoryService] API fetch failed:", error);
    return [];
  }
};

const clearCategoryCache = (): void => {
  categoriesCache = null;
  categoriesPromise = null;
  clearLocalStorage();
};


const getCategory = async () => {
  try {
    const RouteCodes: any = await api
      .get(ApiConstant.getAllCategory)
      .then((result: any) => {
        if (result) return result.data;
        else return null;
      })
      .catch(function (error: any) {
        console.error("error reading get country data.", error);
      });
    const response = RouteCodes != null ? RouteCodes : null;
    return response;
  } catch (e) {
    console.log("error in country");
    return [];
  }
};

const saveCategory = async (newRouteCode: any) => {
  try {
    const RouteCodes: any = await api
      .post(ApiConstant.getAllCategory, newRouteCode)
      .then((result: any) => {
        if (result) return result.data;
        else return null;
      })
      .catch(function (error: any) {
        console.error("error reading get country data.", error);
      });
    const response = RouteCodes != null ? RouteCodes : null;
    return response;
  } catch (e) {
    console.log("error in country");
    return [];
  }
};
const updateCategory = async (updateRouteCodes: any) => {
  try {
    const RouteCodes: any = await api
      .put(ApiConstant.getAllCategory, updateRouteCodes)
      .then((result: any) => {
        if (result) return result.data;
        else return null;
      })
      .catch(function (error: any) {
        console.error("error reading country data.", error);
      });
    const response = RouteCodes != null ? RouteCodes : null;
    return response;
  } catch (e) {
    console.log("error in country");
    return [];
  }
};
const deleteRouteCode = async (addressId: number) => {
  try {
    console.warn(ApiConstant.deleteRouteCodeApi + addressId);
    await api
      .delete(ApiConstant.deleteRouteCodeApi + addressId)
      .then((res: any) => {
        if (res) return res.data;
        else return null;
      })
      .catch(function (error: any) {
        console.error("error deleting Routes data.", error);
      });
  } catch {
    console.log("error in Routes user address");
    return;
  }
};

const CategoryService = {
  getCategory,
  saveCategory,
  updateCategory,
  deleteRouteCode,
  getAllCategories,
  clearCategoryCache
};

export default CategoryService;
